import React, { useState, useEffect } from "react";
import axios from "../context/axiosConfig";
import requireAuth from "../context/requireAuth";
import { Link, useParams, useNavigate } from "react-router-dom";

function EditPlot({ match }) {
  const [plotData, setPlotData] = useState(null);
  const [plotId, setPlotId] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const org_id = localStorage.getItem("organization");

  useEffect(() => {
    const fetchPlotData = async () => {
        
      try {
        const response = await axios.get(`orgs/${org_id}/plots/${id}`, { withCredentials: true });
        setPlotData(response.data);
        setPlotId(response.data.org_plot_no);
      } catch (error) {
        // Handle error
      }
    };

    fetchPlotData();
  }, [id]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.patch(`orgs/${org_id}/plots/${id}`, {
        plotno: event.target.plotNo.value,
        size_x: parseInt(event.target.cols.value),
        size_y: parseInt(event.target.rows.value),
        description: event.target.desc.value
      }, { withCredentials: true });
      // Handle successful patch request
    } catch (error) {
      // Handle error
    }
    navigate(-1);
  };

  return plotData ? (
    <div className="bodyContent">
      <h1 className="title">Edit Plot {plotId}</h1>
      <div className="editFormDiv">
        <form onSubmit={handleSubmit} className="editForm">
          <label htmlFor="plotNo">Plot Name</label>
          <input
            type="text"
            name="plotNo"
            id="plotNo"
            className="editInput newMaintenanceInput"
            defaultValue={plotData.plotno}
          />
          <br />
          <label htmlFor="cols">Columns</label>
          <input
            type="number"
            name="cols"
            id="cols"
            className="editInput newMaintenanceInput"
            defaultValue={plotData.size_x}
          />
          <br />
          <label htmlFor="rows">Rows</label>
          <input
            type="number"
            name="rows"
            id="rows"
            className="editInput newMaintenanceInput"
            defaultValue={plotData.size_y}
          />
          <br />
            <label htmlFor="desc">Description</label>
            <textarea
              name="desc"
              id="desc"
              className="editInput newMaintenanceInput"
              cols="30"
              rows="10"
              defaultValue={plotData.description}
            ></textarea>

          <input type="submit" value="Edit Plot" className="maintenanceFormSubmit" />
        </form>
      </div>
    </div>
  ) : (
    <div>Loading plot data...</div>
  );
}

export default requireAuth(EditPlot);
